const NBSP = ' '

/** "42 900 Ft" — space thousands separator (NBSP so prices never wrap). */
export function fmtFt(amount: number): string {
	const n = Math.round(amount)
	const grouped = Math.abs(n)
		.toString()
		.replace(/\B(?=(\d{3})+(?!\d))/g, NBSP)
	return `${n < 0 ? '-' : ''}${grouped}${NBSP}Ft`
}

const DAY_NAMES = ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat']
const MONTH_ABBR = ['jan.', 'febr.', 'márc.', 'ápr.', 'máj.', 'jún.', 'júl.', 'aug.', 'szept.', 'okt.', 'nov.', 'dec.']

/** "ma, aug. 6., 17:00–18:00" / "csütörtök, aug. 7., 14:00–15:00" — the
    handoff's slot-label shape. */
export function formatSlotLabel(date: string, time: string): string {
	const d = new Date(`${date}T00:00:00`)
	const today = new Date()
	today.setHours(0, 0, 0, 0)
	const diffDays = Math.round((d.getTime() - today.getTime()) / 86400000)

	let dayWord: string
	if (diffDays === 0) dayWord = 'ma'
	else if (diffDays === 1) dayWord = 'holnap'
	else dayWord = DAY_NAMES[d.getDay()]

	const hour = parseInt(time.slice(0, 2), 10)
	const range = `${String(hour).padStart(2, '0')}:00–${String(hour + 1).padStart(2, '0')}:00`
	return `${dayWord}, ${MONTH_ABBR[d.getMonth()]} ${d.getDate()}., ${range}`
}

/** Short chip label for a slot: "Ma 17:00–18:00". */
export function formatSlotChip(date: string, time: string): string {
	const label = formatSlotLabel(date, time)
	return label.charAt(0).toUpperCase() + label.slice(1)
}

/** "+36 30 123 4567" from whatever the transcription produced. */
export function formatPhone(raw: string): string {
	const digits = raw.replace(/\D+/g, '')
	let rest = digits
	if (rest.startsWith('36')) rest = rest.slice(2)
	else if (rest.startsWith('06')) rest = rest.slice(2)
	if (rest.length === 9) {
		return `+36${NBSP}${rest.slice(0, 2)}${NBSP}${rest.slice(2, 5)}${NBSP}${rest.slice(5)}`
	}
	return raw.trim()
}

/** Normalized dial form (+3630...) for the order API; '' when not phone-like. */
export function normalizePhone(raw: string): string {
	const digits = raw.replace(/\D+/g, '')
	let rest = digits
	if (rest.startsWith('36')) rest = rest.slice(2)
	else if (rest.startsWith('06')) rest = rest.slice(2)
	return rest.length >= 8 && rest.length <= 10 ? `+36${rest}` : ''
}
